import serviceBase from '@/services/serviceBase'
import { ApiBooleanResult, ApiResult } from '@/services/data'

export interface UserApiModel {
  AccountName: string;
  Key: string;
  Secret: string;
  Passphrase: string;
  RsaPrivateKey: string;
  CheckingIdleFunds: boolean;
}

export default {
  async listByName (apiName: string): Promise<ApiResult<UserApiModel[]>> {
    return await serviceBase.tryPostResult<UserApiModel[]>(`/UserApi/ListByName?apiName=${apiName}`)
  },
  async addOrUpdate (apiName: string, settings: UserApiModel[]): Promise<ApiBooleanResult> {
    return await serviceBase.tryPostBooleanResult(`/UserApi/addOrUpdate?apiName=${apiName}`, settings)
  }
}
